<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: the role is bound dynamically to tab/radio, which Biome cannot resolve statically -->
<script lang="ts" setup>
  import { computed, useId } from 'vue';
  import {
    tabItemClass,
    tabItemActiveClass,
    underlineClass,
    underlineActiveClass,
  } from './TabItem.css';
  import { TabItemVariant, type TabItemProps } from './TabItem.types';

  const props = withDefaults(defineProps<TabItemProps>(), {
    variant: TabItemVariant.TAB,
    focusable: undefined,
  });

  const emit = defineEmits<{
    select: [];
  }>();

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-tab-item-${uid}`);

  const isTab = computed(() => props.variant === TabItemVariant.TAB);

  const itemClasses = computed(() => [
    tabItemClass,
    { [tabItemActiveClass]: props.active },
  ]);

  const underlineClasses = computed(() => [
    underlineClass,
    { [underlineActiveClass]: props.active },
  ]);
</script>

<template>
  <div
    :class="itemClasses"
    :id="tabId"
    :role="isTab ? 'tab' : 'radio'"
    :aria-selected="isTab ? active : undefined"
    :aria-checked="isTab ? undefined : active"
    :aria-controls="isTab ? ariaControls : undefined"
    :tabindex="(focusable ?? active) ? 0 : -1"
    :data-testid="resolvedTestId"
    @click="emit('select')"
    @keydown.enter="emit('select')"
    @keydown.space.prevent="emit('select')"
  >
    <span>{{ label }}</span>
    <div :class="underlineClasses" />
  </div>
</template>
